import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQuery } from '@react-hook/media-query';
import { mediaQuery } from '@modernhealth/vital-foundation';
import clsx from 'clsx';
import { DeprecatedReactRouterLink as Link } from '../Link/DeprecatedReactRouterLink';
import { BodyTextXSmall, ComponentTextSmall, HeadingText30, HeadingText40, } from '../Typography/Typography';
import { SkeletonPlaceholder } from '../Skeleton/SkeletonPlaceholder';
import * as styles from './SectionHeader.module.scss';
export var SectionHeaderTestID;
(function (SectionHeaderTestID) {
    SectionHeaderTestID["Container"] = "SectionHeaderTestID.Container";
    SectionHeaderTestID["SecondaryTextButton"] = "SectionHeaderTestID.SecondaryTextButton";
})(SectionHeaderTestID || (SectionHeaderTestID = {}));
const Name = 'SectionHeader';
export const SectionHeader = ({ title, secondaryText, secondaryTextLink, onSecondaryTextPress, noMarginTop = false, trackClickCallback, }) => {
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));
    const shouldShowSecondaryTextButton = secondaryText && (onSecondaryTextPress || secondaryTextLink);
    const TextComponent = smallScreenDetected ? HeadingText30 : HeadingText40;
    const SecondaryTextComponent = smallScreenDetected
        ? BodyTextXSmall
        : ComponentTextSmall;
    const classNames = clsx([
        styles.container,
        noMarginTop && styles.noMarginTop,
    ]);
    return (_jsxs("div", { className: classNames, "data-component": Name, "data-testid": SectionHeaderTestID.Container, children: [_jsx(TextComponent, { marginBottom: 0, children: title }), shouldShowSecondaryTextButton &&
                (secondaryTextLink ? (_jsx(Link, { to: secondaryTextLink, onClick: trackClickCallback, "data-testid": SectionHeaderTestID.SecondaryTextButton, children: _jsx(SecondaryTextComponent, { fontColor: "blue55", marginTop: 3, children: secondaryText }) })) : (_jsx("div", { className: styles.secondaryTextButton, onClick: () => {
                        onSecondaryTextPress?.();
                        trackClickCallback?.();
                    }, "data-testid": SectionHeaderTestID.SecondaryTextButton, children: _jsx(SecondaryTextComponent, { fontColor: "blue55", marginTop: 3, children: secondaryText }) })))] }));
};
export const SectionHeaderSkeleton = ({ showSecondaryButton, noMarginTop = false, }) => (_jsxs("div", { className: clsx([styles.container, noMarginTop && styles.noMarginTop]), children: [_jsx(SkeletonPlaceholder, { width: 180, height: 25, borderRadius: 4 }), showSecondaryButton && (_jsx(SkeletonPlaceholder, { width: 50, height: 25, borderRadius: 4 }))] }));
